import request from "@/axios";

// 查询榜单内容管理列表
export const getListContent = (params) => {
  return request({
    url: '/lebo-card/AppCardThirdPartyApp/page',
    method: 'get',
    params
  })
}

// 查询榜单内容管理列表
export const getListContentDetail = (params) => {
  return request({
    url: '/lebo-card/AppCardThirdPartyApp/detail',
    method: 'get',
    params
  })
}

// 删除榜单内容管理列表
export const deleteListContent = (data) => {
  return request({
    url: '/lebo-card/AppCardThirdPartyApp/delete',
    method: 'post',
    data
  })
}

// 新增榜单内容管理列表
export const addListContent = (data) => {
  return request({
    url: '/lebo-card/AppCardThirdPartyApp/add',
    method: 'post',
    data
  })
}

// 编辑榜单内容管理列表
export const updateListContent = (data) => {
  return request({
    url: '/lebo-card/AppCardThirdPartyApp/update',
    method: 'put',
    data
  })
}

/** 查看日志接口 */
export const getLogList = (params) => {
  return request({
    url: "/lebo-card/web/card/operation-log/page",
    method: "get",
    params: {
      ...params,
      module: 4
    }
  });
}